import { useState, useEffect, Suspense } from "react";
import { apiService } from "../../api/apiAdapter";
import { createUser } from "../../api/salesforceB2CApi";
import PasswordChangeModal from "./passwordChangeModal";

const SalesforceManageUsers = (props) => {
  const { subscriptions, mainAccountContact } = props;
  const [showUserForm, setShowUserForm] = useState(false);
  const [formData, setFormData] = useState({
    email: "",
    password: "",
    firstName: "",
    lastName: "",
    contactid: "",
  });
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [showPasswordRequirements, setShowPasswordRequirements] = useState(false);
  const [licenseInfo, setLicenseInfo] = useState({
    totalLicenses: 0,
    availableLicenses: 0,
  });
  const [users, setUsers] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  //for password modal
  const [showPasswordModal, setShowPasswordModal] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [showSubscribeButton, setShowSubscribeButton] = useState(true);

  useEffect(() => {
    fetchChildContacts();
  }, [mainAccountContact?.contactid, subscriptions]);

  const PasswordRequirements = () => (
    <div className="password-requirements mt-2" style={{ fontSize: "0.85em", color: "#666" }}>
      <div className="alert alert-info">
        <strong>Password Requirements:</strong>
        <ul className="mb-0 mt-1">
          <li>Must be between 8 and 256 characters</li>
          <li>
            Must contain at least 3 of the following:
            <ul>
              <li>Lowercase letters (a-z)</li>
              <li>Uppercase letters (A-Z)</li>
              <li>Numbers (0-9)</li>
              <li>
                Special characters (@ # $ % ^ &amp; * - _ + = [ ] {} | \ : ' , ? / ` ~ " ( ) ; .)
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
  );

  const toggleUserForm = () => {
    setShowUserForm(!showUserForm);
    setFormData({
      email: "",
      password: "",
      firstName: "",
      lastName: "",
      contactid: "",
      // relationId: "",
    });
    setError("");
    setSuccess("");
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const fetchChildContacts = async () => {
    if (!mainAccountContact?.accountId || !subscriptions) {
      console.error("Main account contact ID or subscriptions not available");
      return;
    }

    setIsLoading(true);
    try {
      // const response = await apiService.getChildContacts(
      //   mainAccountContact.accountId,
      // );
      const response = await apiService.getChildContacts(subscriptions?.entitlementid);
      //console.log("Child contacts response:", response);

      if (response.success && response.contacts) {
        const formattedUsers = [];
        // console.log("Child contacts with active status:", response.contacts);
        response.contacts.map((contact) => {
          if (contact.contactId === mainAccountContact.contactid) {
            setShowSubscribeButton(!contact.isActive);
            // setMainAccountContactRelationId(contact.relationId);
          }
          const child = {
            appIdentifierId: contact.appIdentifierId,
            // relationId: contact.relationId,
            email: contact.email,
            firstName: contact.firstName,
            lastName: contact.lastName,
            contactId: contact.contactId,
            phone: contact?.phone,
            status: contact.status,
          };
          if (contact.isActive) {
            // only pushing active contacts to list
            formattedUsers.push(child);
          }
          return { ...child, isActive: contact.isActive }; // this list contains both active and inactive contacts which is used for checking in add user if user exist with inactive status then activating the relation instead of creating new contact and relation in salesforce
        });
        let usedLicenses = formattedUsers.length;
        const totalLicenses = subscriptions.tg_numberoflicences || 0;

        const availableLicenses = totalLicenses - usedLicenses;

        setUsers(formattedUsers); // after appIdentifier both will be same  AllChildrenContacts and  formattedUsers

        setLicenseInfo({
          totalLicenses,
          availableLicenses,
        });
      } else {
        console.error("Invalid response format:", response);
        setError("Failed to load user list: Invalid response format");
      }
    } catch (error) {
      console.error("Error fetching child contacts:", error);
      setError("Failed to load user list");
    } finally {
      setIsLoading(false);
    }
  };

  const addUser = async () => {
    setError("");
    setSuccess("");

    if (!formData.email || !formData.password || !formData.firstName || !formData.lastName) {
      setError("Please provide all required fields: First Name, Last Name, Email, and Password");
      return;
    }

    if (licenseInfo.availableLicenses <= 0) {
      setError("No licenses available");
      return;
    }
    if (formData?.email.toLowerCase() === mainAccountContact?.emailaddress1.toLowerCase()) {
      setError(
        "You are trying to create a user with main account email. please click on subscribe myself button to subscribe yourself.",
      );
      return;
    }
    // let relationIdforExistingContact = null;
    console.log(
      "All children contacts before adding user:",
      users.some((user) => user.email.toLowerCase() === formData.email.toLowerCase()),
    );
    if (users.some((user) => user.email.toLowerCase() === formData.email.toLowerCase())) {
      setError("A user with this email already exists.");
      return;
    }

    setIsLoading(true);
    try {
      if (formData.email.toLowerCase() !== mainAccountContact?.emailaddress1.toLowerCase()) {
        try {
          const b2cResponse = await createUser(
            formData.email,
            formData.password,
            formData.firstName,
            formData.lastName,
          );
          // console.log("B2C user creation response:", b2cResponse); //for this  b2cResponse?.code !== "UserExists"   never comes it directly gows to catch

          if (b2cResponse?.message !== "User created successfully") {
            throw new Error("Failed to create user");
          }
        } catch (b2cError) {
          if (b2cError?.code === "UserExists") {
            setError(
              "The email address you have entered already exists in our system. Reactivated again with the same email.",
            );
            // as email already exist still it should continue for  apiService.createOrUpdateMultiuser
          } else {
            console.error("Error creating user error:", b2cError); // should comment
            throw new Error("Failed to create user");
          }
        }

        await apiService.createOrUpdateMultiuser(
          {
            firstName: formData.firstName,
            lastName: formData.lastName,
            password: formData.password,
            emailaddress1: formData.email,
            parentMultiUser: false,
            // accountId: mainAccountContact?.accountId,
            // relationIdforExistingContact, // this make salesforce relationship active too another call in backend also there
          },
          {
            applicationId: subscriptions?.applicationid,
            institutionSubscriptionId: subscriptions?.entitlementid,
          },
        );

        await fetchChildContacts(); // this needed because after creating contact can't get relationId only get contactId in response so fetching the list again to get updated list with relationId and contactId which are needed for delete operation
        // Refresh the user list to reflect the new user and updated license count
        setSuccess("User created successfully");
        setFormData({ email: "", password: "", firstName: "", lastName: "" });
        setShowUserForm(false);
      }
    } catch (error) {
      console.error("Error in user creation:", error);
      setError(error.message || "Failed to create user");
    } finally {
      setIsLoading(false);
    }
  };

  const deleteUser = async (userEmail, userContactId, appIdentifierId) => {
    if (!userEmail || !userContactId || !appIdentifierId) {
      setError("Missing user information for deletion.");
      console.error("Missing user information for deletion:", {
        userEmail,
        userContactId,
        appIdentifierId,
      });
      return;
    }
    if (!window.confirm(`Are you sure you want to delete user ${userEmail}?`)) {
      return;
    }
    setError("");
    setSuccess("");
    setIsLoading(true);

    try {
      const response = await apiService.deleteAppIdentifier(appIdentifierId);
      if (response.success) {
        setShowSubscribeButton(userContactId === mainAccountContact.contactid);
      } else {
        throw new Error("Failed to delete user from Salesforce");
      }

      setUsers((prevUsers) =>
        prevUsers.filter((u) => u.email.toLowerCase() !== userEmail.toLowerCase()),
      );
      setLicenseInfo((prev) => ({
        ...prev,
        availableLicenses: prev.availableLicenses + 1,
      }));
      await fetchChildContacts(); // for updating also AllChildrenContact also
      setSuccess("User removed successfully.");
    } catch (error) {
      console.error("Error deleting user:", error);
      setError(error.message || "Failed to remove user.");
    } finally {
      setIsLoading(false);
    }
  };

  const subscribeMyself = async () => {
    setIsLoading(true);
    try {
      const response = await apiService.createOrUpdateMultiuser(
        {
          firstName: mainAccountContact.firstName,
          lastName: mainAccountContact.lastName,
          emailaddress1: mainAccountContact.emailaddress1,
          parentMultiUser: true,
        },
        {
          applicationId: subscriptions?.applicationid,
          institutionSubscriptionId: subscriptions?.entitlementid,
        },
      );
      if (!response.success) {
        throw new Error("Failed to self subscribe user");
      }
      setSuccess("Successfully subscribed yourself");
      setLicenseInfo((prev) => ({
        ...prev,
        availableLicenses: prev.availableLicenses - 1,
      }));
      setUsers((prevUsers) => [
        ...prevUsers,
        {
          email: mainAccountContact.emailaddress1,
          firstName: mainAccountContact.firstName,
          lastName: mainAccountContact.lastName,
          contactId: mainAccountContact.contactid,
        },
      ]);
      await fetchChildContacts();
      setShowSubscribeButton(false);
    } catch (error) {
      setError("Failed to subscribe: " + error.message);
      console.error("Error subscribing:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handlePasswordUpdateSuccess = (message) => {
    setSuccess(message);
    setTimeout(() => {
      setSuccess("");
    }, 10000);
  };

  return (
    <>
      <Suspense fallback={<div className="loader"></div>}>
        <div role="tabpanel" className="tab-pane active" id="manageUsers">
          <div className="license-no">
            Total licenses:{" "}
            <strong className="marginLeft3px badge" id="totalLicenses">
              {licenseInfo.totalLicenses}
            </strong>{" "}
            | Licenses available:{" "}
            <strong className="marginLeft3px badge" id="availableLicenses">
              {licenseInfo.availableLicenses}
            </strong>
          </div>

          {isLoading ? (
            <div className="loader"></div>
          ) : (
            <table className="table table-bordered" id="manage-user-table">
              <thead className="thead_bg">
                <tr>
                  <th>Email</th>
                  <th>Name</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {users && users.length > 0 ? (
                  users.map((user, index) => (
                    <tr key={user.contactId || index}>
                      <td data-label="Email">
                        {" "}
                        <div style={{ padding: "6px" }}>{user.email}</div>
                      </td>
                      <td data-label="Name">
                        <div style={{ padding: "6px" }}>{`${user.firstName} ${user.lastName}`}</div>
                      </td>
                      <td data-label="Actions">
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "10px",
                            justifyContent: "flex-start",
                          }}
                        >
                          <button
                            title="Delete User"
                            className="btn btn-link marginRight15px"
                            style={{
                              padding: "6px",
                              minWidth: "30px",
                              color: "#d9534f", // danger color
                            }}
                            onClick={() =>
                              deleteUser(user.email, user.contactId, user.appIdentifierId)
                            }
                          >
                            <i className="fa fa-trash-o"></i>
                          </button>
                          <button
                            className="btn-link clrBlue"
                            style={{
                              padding: "6px 0",
                              border: "none",
                              background: "none",
                              font: "inherit",
                              textDecoration: "underline",
                              whiteSpace: "nowrap",
                            }}
                            onClick={() => {
                              setSelectedUser(user);
                              setShowPasswordModal(true);
                            }}
                          >
                            change password
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="3" className="text-center">
                      No users found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          )}

          {/* Buttons for new user creation / subscribing */}
          {!showUserForm && licenseInfo.availableLicenses > 0 && (
            <p className="text-right noBtmMarging">
              {showSubscribeButton && (
                <button
                  type="button"
                  className="btn btn-primary btn-sm borderNone marginRight10"
                  onClick={() => subscribeMyself()}
                >
                  Subscribe myself
                </button>
              )}
              <button
                type="button"
                className="btn btn-info btn-sm borderNone"
                onClick={toggleUserForm}
              >
                Create User
              </button>
            </p>
          )}

          {error && (
            <div className="alert alert-danger" role="alert">
              {error}
            </div>
          )}
          {success && (
            <div className="alert alert-success" role="alert">
              {success}
            </div>
          )}

          {/* Form for adding a new user */}
          {showUserForm && (
            <div>
              <table className="table table-bordered add-child-user">
                <thead className="thead_bg">
                  <tr>
                    <th style={{ width: "25%" }}>First Name</th>
                    <th style={{ width: "25%" }}>Last Name</th>
                    <th style={{ width: "25%" }}>Email</th>
                    <th style={{ width: "25%" }}>
                      Password
                      <i
                        className="fa fa-info-circle ml-2"
                        onMouseEnter={() => setShowPasswordRequirements(true)}
                        onMouseLeave={() => setShowPasswordRequirements(false)}
                        style={{ cursor: "help", marginLeft: "2px" }}
                      ></i>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td data-label="First Name">
                      <input
                        type="text"
                        name="firstName"
                        value={formData.firstName || ""}
                        onChange={handleInputChange}
                        className="form-control"
                        placeholder="Enter first name"
                        required
                      />
                    </td>
                    <td data-label="Last Name">
                      <input
                        type="text"
                        name="lastName"
                        value={formData.lastName || ""}
                        onChange={handleInputChange}
                        className="form-control"
                        placeholder="Enter last name"
                        required
                      />
                    </td>
                    <td data-label="Email">
                      <input
                        type="email"
                        name="email"
                        value={formData.email || ""}
                        onChange={handleInputChange}
                        className="form-control"
                        placeholder="Enter email"
                        required
                      />
                    </td>
                    <td data-label="Password">
                      <input
                        type="password"
                        name="password"
                        value={formData.password || ""}
                        onChange={handleInputChange}
                        className="form-control"
                        placeholder="Enter password"
                        required
                      />
                      {showPasswordRequirements && <PasswordRequirements />}
                    </td>
                  </tr>
                </tbody>
              </table>

              <p className="text-right noBtmMarging">
                <button
                  type="button"
                  className="btn btn-default btn-sm marginRight10"
                  onClick={toggleUserForm}
                >
                  Cancel
                </button>
                <button type="button" className="btn btn-info btn-sm borderNone" onClick={addUser}>
                  Add User
                </button>
              </p>
            </div>
          )}

          {/* Password modal */}
          {showPasswordModal && (
            <PasswordChangeModal
              show={showPasswordModal}
              onClose={() => setShowPasswordModal(false)}
              user={selectedUser}
              onSuccess={(msg) => handlePasswordUpdateSuccess(msg)}
            />
          )}
        </div>
      </Suspense>
    </>
  );
};

export default SalesforceManageUsers;
